<template>
    <div class="slider">

        <img class="background" :src="`/images/slider/cet-${imageIndex}.jpg`" alt="" role="presentation">

        <div class="information">

                <div class="title-wrap">
                    <h1 class="font-app-bold title text-center" v-html="__('Looking for:br Electrical Education?', { br: `<br class=\d-none d-md-block\>` })"></h1>
                </div>

               <div class="links">

                   <div class="link-item">
                       <a class="btn btn-app-blue font-app-medium" href="/electrical-training-program">
                           <span v-html="__('Electrician Trainee:br Program', {br: `<br class=\d-lg-none\>`})"></span>
                       </a>
                  </div>

                   <div class="link-item">
                       <a class="btn btn-app-blue font-app-medium" href="/continuous-education-units">
                           <span v-html="__('Continuous Education', {br: `<br class=\d-lg-none\>`})"></span>
                       </a>
                   </div>

                   <div class="link-item">
                       <a class="btn btn-app-blue font-app-medium" href="/lab-classes">
                           <span v-html="__('On-Site Lab:br Training', {br: `<br class=\d-lg-none\>`})"></span>
                       </a>
                   </div>

                </div>
            </div>
        </div>
</template>
<script>
    export default {

        data() {
            return {
                interval: null,
                imageIndex: 1,
            }
        },

        created() {
            this.imageIndex = _.random(1, 14);
            this.interval = setInterval(() => {
                this.imageIndex = _.random(1, 14);
            }, 5000);
        },

        beforeDestroy() {
            clearInterval(this.interval)
        }
    }
</script>
